import { FormlyFieldConfig } from '@ngx-formly/core';

export let FilterFieldsConfig1: FormlyFieldConfig[] = [
  {
    key: 'keyword',
    type: 'autocomplete',
    className: 'grid-col-12',
    props: {
      type: 'text',
      hideOptional: true,
      label: 'Keyword',
      configuration: {
        primaryKeyField: 'key',
        primaryTextField: 'text',
        autocompletePlaceHolderText: 'e.g. Company Name',
        isTagModeEnabled: true,
        labelText: 'Keyword',
        id: 'keyword',
      },
    },
  },
  {
    key: 'requestedBy',
    type: 'autocomplete',
    className: 'grid-col-12',
    props: {
      type: 'text',
      hideOptional: true,
      label: 'Requested By',
      configuration: {
        primaryKeyField: 'key',
        primaryTextField: 'text',
        autocompletePlaceHolderText: 'e.g. John Smith',
        isTagModeEnabled: true,
        labelText: 'Requested By',
        id: 'requestedBy',
      },
    },
  },
  {
    key: 'respondedBy',
    type: 'autocomplete',
    className: 'grid-col-12',
    props: {
      type: 'text',
      hideOptional: true,
      label: 'Responded By',
      configuration: {
        primaryKeyField: 'key',
        primaryTextField: 'text',
        autocompletePlaceHolderText: 'e.g. Adam Kelly',
        isTagModeEnabled: true,
        labelText: 'Responded By',
        id: 'respondedBy',
      },
    },
  },
  {
    key: 'agencyPicker',
    type: 'agency-picker',
    props: {
      label: 'Federal Organizations',
      type: 'plain',
      hideOptional: true,
      selectionType: 'checkbox',
      countFieldLevel: 2,
      inactiveToggle: false,
      model: {},
      simpleResponse: true,
      placeholder: '',
      //"focus": false,
      disabled: false,
      lockOnRoleAdminHierarchy: '',
      excludesNamedOrg: '',
      isDefaultDept: false,
      hint: 'Enter your Department, Ind. Agency, Subtier, Office, or other organization.',
      modalHint: '',
      errorMessage: '',
      requiredFlag: false,
      prefix: '',
      lockOnRoleAdminHierarchyInitialEmit: true,
      adminHierarchy: false,
      defaultRoles: false,
      status: 'active',
      domain: '',
      role: '',
      hasFpds: false,
      fieldLevels: '',
      displayAdvanceButton: true,
    },
    id: 'formly_3_agency-picker_agencyPicker_1',
    hooks: {},
    modelOptions: {},
    validation: { messages: {} },
    wrappers: [
      'animation',
      'group',
      'readonly',
      'label',
      'description',
      'validation',
    ],
    //"keyPath": { "key": "agencyPicker", "path": [ "agencyPicker" ] }
  },
  {
    key: 'reqType',
    props: { label: 'Request Type', group: 'accordion' },
    fieldGroup: [
      {
        key: 'administration',
        type: 'multicheckbox',
        defaultValue: { '9,11,1': false },
        props: {
          label: 'Administration',
          //description: 'Select any socio-economic categories which reflect the current status of your entity',
          selectAllOption: true,
          hideOptional: true,
          options: [
            {
              value: '9,11',
              label: 'Invite Role',
            },
            {
              value: '1',
              label: 'Request Role',
            },
          ],
        },
      },
      {
        key: 'acquisitionInformation',
        type: 'multicheckbox',
        defaultValue: { 10: false },
        props: {
          label: 'Acquisition Information',
          selectAllOption: true,
          options: [
            {
              value: '10',
              label: 'Access Opportunity Attachment',
            },
          ],
        },
      },
      {
        key: 'entityInformation',
        type: 'multicheckbox',
        defaultValue: { 12: false },
        props: {
          label: 'Entity Information',
          selectAllOption: true,
          options: [
            {
              value: '12',
              label: 'Register Entity',
            },
          ],
        },
      },
      {
        key: 'federalAssistanceInformation',
        type: 'multicheckbox',
        defaultValue: {
          7: false,
          8: false,
          2: false,
          3: false,
          6: false,
          4: false,
          5: false,
        },
        props: {
          label: 'Federal Assistance Information',
          selectAllOption: true,
          options: [
            {
              value: '7',
              label: 'Submit Listing',
            },
            {
              value: '8',
              label: 'Publish Listing',
            },
            {
              value: '2',
              label: 'Change Listing Title',
            },
            {
              value: '3',
              label: 'Change Listing Number',
            },
            {
              value: '6',
              label: 'Change Listing Subtier',
            },
            {
              value: '4',
              label: 'Archive Listing',
            },
            {
              value: '5',
              label: 'Unarchive Listing',
            },
          ],
        },
      },
    ],
  },
  {
    key: 'reqByDomain',
    props: {
      /*label: 'Requests By Domain', group: 'accordion'*/
    },
    fieldGroup: [
      /*  {
        key: 'reqByDomainCheckbox',
        type: 'multicheckbox',
        defaultValue: { 9: false, 2: false, 18: false },
        props: {
          hideOptional: true,
        },
      }, */
    ],
  },
  {
    key: 'reqStatus',
    props: { label: 'Request Status', group: 'accordion' },
    fieldGroup: [
      {
        key: 'reqStatusCheckbox',
        type: 'multicheckbox',
        defaultValue: {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
        },
        props: {
          hideOptional: true,
          options: [
            {
              value: '1',
              label: 'Pending',
            },
            {
              value: '2',
              label: 'Approved',
            },
            {
              value: '3',
              label: 'Rejected',
            },
            {
              value: '4',
              label: 'Cancelled',
            },
            {
              value: '5',
              label: 'Complete',
            },
            {
              value: '6',
              label: 'Declined',
            },
            {
              value: '7',
              label: 'Accepted',
            },
          ],
        },
      },
    ],
  },
];

export const RequestedByDomainOptions = [
  {
    value: '1',
    label: 'Contract Data',
  },
  {
    value: '2',
    label: 'Contract Opportunities',
  },
  {
    value: '3',
    label: 'Performance & Integrity Information',
  },
  {
    value: '4',
    label: 'Identity And Access Management',
  },
  {
    value: '5',
    label: 'Federal Hierarchy',
  },
  {
    value: '7',
    label: 'Wage Determinations',
  },
  {
    value: '8',
    label: 'Sub-Awards_Esrs',
  },
  {
    value: '9',
    label: 'Assistance Listing',
  },
  {
    value: '10',
    label: 'Admin',
  },
  {
    value: '12',
    label: 'Sub-Awards_Fsrs',
  },
  {
    value: '13',
    label: 'Sub-Awards',
  },
  {
    value: '16',
    label: 'ALL',
  },
  {
    value: '17',
    label: 'Exclusions',
  },
  {
    value: '18,14',
    label: 'Entity Registration',
  },
  {
    value: '19,15',
    label: 'Entity Compliance',
  },
  {
    value: '21',
    label: 'Customer Service',
  },
];
